import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { binaryFilterOptions, equalFilterOptions, repTypeOptions } from '../Views/selectOptions'
import { FilterField } from './FilterField'
import { SelectField } from './SelectField'

export const RepFields: React.VFC = () => {
    const rep = 'filters.company.rep'
    const repOp = 'filters.company.repOp'
    const repType = 'filters.company.repType'
    const [auctionRepOpOptions, setAuctionRepOpOptions] = React.useState(binaryFilterOptions)
    const { setValue, getValues } = useFormContext()
    const currentRepOp = useWatch({ name: repOp }) as string
    const currentRepType = useWatch({ name: repType }) as string

    React.useEffect(() => {
        if (!currentRepOp) {
            return setValue(repType, '')
        }
        const selectedRepType = getValues(repType) as string
        return selectedRepType ? undefined : setValue(repType, 'ALL')
    }, [setValue, currentRepOp, getValues])

    // TODO: Remove once repsellerNot & repbuyerNot are implemented
    React.useEffect(() => {
        if (currentRepType === 'SELLER' || currentRepType === 'BUYER') {
            setAuctionRepOpOptions(equalFilterOptions)
            setValue(repOp, 'equals')
        } else {
            setAuctionRepOpOptions(binaryFilterOptions)
        }
    }, [getValues, setValue, currentRepType])

    return (
        <>
            <FilterField
                label="Auction Rep"
                selectProps={{
                    name: repOp,
                    options: auctionRepOpOptions,
                }}
                textFieldProps={{
                    name: rep,
                    placeholder: "Try 'Mark' or 'Jon,Hope'",
                }}
            />
            <SelectField label="Rep Accounts" name={repType} options={repTypeOptions} />
        </>
    )
}
